import React from 'react';
import { Input, Text } from '@musa.tech/design-system';

interface PillRangeProps {
  type: 'month' | 'date';
  from: string;
  to: string;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
}

/**
 * Corpo De/Até dos filtros de período — `month` para competência, `date` para vencimento ou
 * data da solicitação. Sem equivalente no Dashboard (que usa um único range); a casca externa
 * (botão + popover) vem do `FilterDropdownButton`.
 */
export const PillRange: React.FC<PillRangeProps> = ({
  type,
  from,
  to,
  onFromChange,
  onToChange,
}) => (
  <div className="flex flex-col gap-2 p-3">
    <div className="flex flex-col gap-1">
      <Text variant="caption" size="xsmall" className="uppercase tracking-wide text-neutral-500">
        De
      </Text>
      <Input
        type={type}
        value={from}
        max={to || undefined}
        onChange={(event) => onFromChange(event.target.value)}
        className="h-9 text-sm"
      />
    </div>
    <div className="flex flex-col gap-1">
      <Text variant="caption" size="xsmall" className="uppercase tracking-wide text-neutral-500">
        Até
      </Text>
      <Input
        type={type}
        value={to}
        min={from || undefined}
        onChange={(event) => onToChange(event.target.value)}
        className="h-9 text-sm"
      />
    </div>
  </div>
);
